module.exports = __webpack_public_path__ + "img/mediaPackages.6b012eec.svg";